import type { SVGProps } from "react";
export interface OvenIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function OvenIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: OvenIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 6c0-1.036-.84-1.875-1.875-1.875H6c-1.036 0-1.875.84-1.875 1.875v12c0 1.035.84 1.875 1.875 1.875h12c1.035 0 1.875-.84 1.875-1.875zm2.25 12A4.125 4.125 0 0 1 18 22.125H6A4.125 4.125 0 0 1 1.875 18V6A4.125 4.125 0 0 1 6 1.875h12A4.125 4.125 0 0 1 22.125 6z"
      />
      <path
        fill={color}
        d="M7.125 16.875h9.75v-6.75h-9.75zm3.03-5.945a1.123 1.123 0 0 1 .853 2.07l.13.237c.312.574.3 1.222.026 1.76a2.14 2.14 0 0 1-1.085.987l-.201.075-.034.011-.111.03a1.126 1.126 0 0 1-.744-2.104l-.128-.234a1.87 1.87 0 0 1-.026-1.761c.265-.521.742-.887 1.285-1.062l.033-.01Zm4.111-.031A1.124 1.124 0 0 1 15.01 13l.129.237.102.219a1.87 1.87 0 0 1-.076 1.54 2.14 2.14 0 0 1-1.084.988l-.2.075-.034.011a1.124 1.124 0 0 1-.856-2.073l-.129-.235a1.87 1.87 0 0 1-.026-1.761c.265-.522.743-.887 1.286-1.062l.034-.01.111-.031Zm4.859 6.6c0 .898-.727 1.626-1.625 1.627h-11a1.626 1.626 0 0 1-1.625-1.627V9.5c0-.897.727-1.624 1.625-1.625h11c.898 0 1.625.728 1.625 1.625v8ZM9.375 6a1.375 1.375 0 0 1-2.742.141l-.008-.14.008-.141A1.375 1.375 0 0 1 8 4.625l.14.007c.694.07 1.235.656 1.235 1.368m4 0a1.375 1.375 0 0 1-2.743.141l-.008-.14.008-.141a1.375 1.375 0 0 1 2.744.14Zm4 0a1.374 1.374 0 0 1-2.743.141l-.007-.14.007-.141A1.375 1.375 0 0 1 16 4.625l.141.007A1.376 1.376 0 0 1 17.375 6"
      />
    </svg>
  );
}
